// @ts-nocheck
import React, {Component} from 'react'
import Styles from './HcpDetails.module.css'
import apiFetch from '../../api/apiFetch'
import Loading from '../../components/Loading/Loading'
import DetailsInformation from './components/Details_Information'
//import DetailsPriAddress from './components/Details_PriAddress';
import AddressAlignment from "./components/address-alignment/AddressAlignment";
import DetailsAffiliations from './components/Details_Affiliations'
import AddressHistory from './components/Details_Address_History'
import SlnHistory from './components/Details_SLN'
import SlnEdit from './components/Details_SLN_Edit'
import DetailsChangeRequests from './components/Details_ChangeRequests'
import DetailsEdit from './components/Details_Edit'
import AddHCPSuccess from './components/AddHcpSuccess'
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../../AppInsights';
import { withRouter } from '../../utility/withRouter';

class HcpDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            spinning: false,
            addslnsuccess: false,
            pathError: false,
            editsubmitted: false,
            // section state: null = loading, [] = empty
            data: null,
            affiliations: null,
            change: null,
            msl: null,
            sln: null,
            ctmsAddress: null,
            addresses: null,
            degree: null,
            // Local optimistic toggle delta — seeded from core DB flags on load
            toggleState: { crm: undefined, spend: undefined, ctms: undefined },
        };
    }

    addTo(index, i, added, addSpend) {
        let json = {}
        if (added) {
            if (i === 0) {
                json.REQUEST_TYPE = "Remove from - Spend";
            } else if (i === 1) {
                json.REQUEST_TYPE = "Remove from - CRM";
            } else if (i === 2) {
                json.REQUEST_TYPE = "Remove from - CTMS";
            }
        } else {
            if (i === 0) {
                json.REQUEST_TYPE = "Add to - Spend";
            } else if (i === 1) {
                json.REQUEST_TYPE = "Add to - CRM";
            } else if (i === 2) {
                json.REQUEST_TYPE = "Add to - CTMS";
            }
        }

        this.setState(prev => ({
            toggleState: {
                ...prev.toggleState,
                ...(i === 0 ? { spend: !added } : {}),
                ...(i === 1 ? { crm:   !added } : {}),
                ...(i === 2 ? { ctms:  !added } : {}),
            }
        }))

        json.PROF_ID = this.state.data.PROF_ID
        json.REQUESTOR_ID = this.props.user.email
        json.REQUESTOR_NAME = this.props.user.userName
        json.REQUESTOR_TEAM = this.props.user.team
        json.REQUESTOR_TERR = this.props.user.terr

        apiFetch('/api/v2/global/change-request', json).then(() => {
            if (addSpend) {
                let json = {}
                json.REQUEST_TYPE = "Add to - Spend";
                json.PROF_ID = this.state.data.PROF_ID
                json.REQUESTOR_ID = this.props.user.email
                json.REQUESTOR_NAME = this.props.user.userName
                json.REQUESTOR_TEAM = this.props.user.team
                json.REQUESTOR_TERR = this.props.user.terr
                this.setState(prev => ({ toggleState: { ...prev.toggleState, spend: !added } }))
                apiFetch('/api/v2/global/change-request', json)
            }
        })
    }

    addSLN(data) {
        let json = {}

        json.PROF_ID = this.state.data.PROF_ID
        json.ADDRESS1 = data.ADDRESS1
        json.ADDRESS2 = data.ADDRESS2
        json.ZIPCODE = data.ZIP
        json.CITY = data.CITY
        json.REQUESTOR_ID = this.props.user.email
        json.REQUESTOR_NAME = this.props.user.userName
        json.REQUESTOR_TEAM = this.props.user.team
        json.REQUESTOR_TERR = this.props.user.terr
        json.REQUEST_TYPE = "Add to - SLN"; 
        json.DEGREE = data.DEGREE; 
        //json.SLN_EXPIRATION_DATE = data.EXP; 
        json.SLN_EXPIRATION = data.EXP; 
        json.SLN_NUMBER = data.LICENSE; 
        json.STATUS = data.STATUS;
        json.STATE = data.STATE;
        json.LIC_STATE = data.LIC_STATE;
        json.SLNOVERALLSAMPLEABILITY = data.OVERALL_SAMPLEABILITY;
        json.SLN_REASON = data.SLN_REASON;

        apiFetch('/api/v2/global/change-request', json).then(() => {

            this.setState({
                editScreen: undefined,
                addslnsuccess: true
            })


        })
    }

    closeEdit() {
        this.setState({editScreen: undefined})
    }

    refresh(data) {
        let temp = this.state.data;
        let keys = Object.keys(data[0])
        for (let i = 0; i < Object.keys(data[0]).length; i++) {
            if (data[0][keys[i]] !== null) {
                temp[keys[i]] = data[0][keys[i]]
            }
        }
        this.setState({data: temp})
    }

    submitEdit(json, list) {

        if (this.state.editsubmitted === true) { return; }

        this.setState({editsubmitted: true})
        if (!list) {
            json.PROF_ID = this.state.data.PROF_ID
            json.REQUESTOR_ID = this.props.user.email
            json.REQUESTOR_NAME = this.props.user.userName
            json.REQUESTOR_TEAM = this.props.user.team
            json.REQUESTOR_TERR = this.props.user.terr
        }
        apiFetch('/api/v2/global/change-request', json).then((data) => {
            this.setState({ editsubmitted: false });
            this.editScreen(11);
            this.setChange(data);
        }).catch(() => {
            this.setState({ editsubmitted: false });
        })
    }

    editScreen(i, id) {

        console.log(id);

        this.setState({
            editScreen: <DetailsEdit
                editScreen={this.editScreen.bind(this)}
                affiliations={this.state.affiliations}
                data={this.state.data}
                submit={this.submitEdit.bind(this)}
                change={this.state.change}
                addresses={this.state.addresses}
                close={this.closeEdit.bind(this)}
                id={id}
                index={i}
                user={this.props.user}
                msl={this.state.msl}
                setChange={this.setChange.bind(this)}
                updateChanges={this.updateChanges.bind(this)}
            />
        })


    }

    editScreenChangeRequest(i, data) {
        this.setState({
            editScreen: <DetailsEdit
                editScreen={this.editScreen.bind(this)}
                affiliations={this.state.affiliations}
                data={this.state.data}
                submit={this.submitEdit.bind(this)}
                change={data}
                addresses={this.state.addresses}
                close={this.closeEdit.bind(this)}
                index={i}
                user={this.props.user}
                msl={this.state.msl}
                setChange={this.setChange.bind(this)}
                updateChanges={this.updateChanges.bind(this)}
            />
        })
    }

    componentDidMount() {
        this.loadChange();
    }

    loadChange() {

        const pid = this.props.match.params.PROF_ID;
        const json = {
            PROF_ID: pid,
            TEAM: this.props.user.role === 'PRT' || this.props.user.role === 'COMMERCIAL DERM' || this.props.user.isDermAdmin === 'true' ? '31' : this.props.user.team
        };

        // Core resolves first — render header as soon as it arrives
        apiFetch('/api/v2/details/hcp/core', json).then((core) => {
            if (!core || core.length === 0) { this.setState({ pathError: true }); return; }
            const profID = core[0].PROF_ID;
            if (profID != pid) {
                this.setState({ pathError: true });
                console.log('ProfID = ' + profID + ' query string = ' + pid);
                return;
            }
            this.setState({
                data: core[0],
                degree: core[0].DEGREE,
                loaded: true,
                toggleState: {
                    // Left unset until clicked so Details_Information falls back to the
                    // team-specific UNIVERSE_FLAG_TM{team} rules, matching the search results;
                    // seeding from UNIVERSE_FLAG hid team CRM flags.
                    crm:   undefined,
                    spend: core[0].AGGSPEND_FLAG === 'Y',
                    ctms:  core[0].CTMS_FLAG     === 'Y',
                },
            });
        });

        // Secondary sections fire in parallel — each updates state independently
        apiFetch('/api/v2/details/hcp/affiliations', json)
            .then(d => this.setState({ affiliations: d ?? [] }));

        apiFetch('/api/v2/details/hcp/change-requests-display', json)
            .then(d => this.setState({ change: d ?? [] }));

        apiFetch('/api/v2/details/hcp/regional-plan', json).then(d => {
            const msl = {};
            (d || []).forEach(r => { msl[r.ATTR_NAME] = r.ATTR_VALUE; });
            this.setState({ msl });
        });

        apiFetch('/api/v2/details/hcp/sln', json)
            .then(d => this.setState({ sln: d ?? [] }));

        apiFetch('/api/v2/details/hcp/ctms-address', json)
            .then(d => this.setState({ ctmsAddress: d ?? [] }));

        // Address sub-sections arrive as a group — child components expect a 4-slot array
        Promise.all([
            apiFetch('/api/v2/details/hcp/primary-address',     json),
            apiFetch('/api/v2/details/hcp/best-address',        json),
            apiFetch('/api/v2/details/hcp/secondary-addresses', json),
            apiFetch('/api/v2/details/hcp/addresses',           json),
        ]).then(([pri, best, sec, addr]) => {
            this.setState({ addresses: [pri ?? [], best ?? [], sec ?? [], addr ?? []] });
        });
    }

    setChange() {
        apiFetch('/api/v2/details/hcp/change-requests', {PROF_ID: this.state.data.PROF_ID}).then((data) => {
            if (this.state.editScreen) {
                this.editScreen(11)
            }
            this.setState({
                change: data
            })
        })
    }

    updateChanges() {
        this.loadChange()
    }

    close() {
        this.setState({changeViewValue: -1})
    }

    openSLNEdit() {

        this.setState({
            editScreen: <SlnEdit close={this.closeSlnEdit.bind(this)} degree={this.state.degree} address={this.state.addresses[0]} addSln={this.addSLN.bind(this)} />
        })
    }
    closeSlnEdit() {
        this.setState({
            editScreen: undefined
        })
    }
    closeSlnSuccess() {
        this.setState({
            successScreen: undefined,
            addslnsuccess: false
        })
    }
    
    render() {
        let successDialog = this.state.addslnsuccess? (<AddHCPSuccess close={this.closeSlnSuccess.bind(this)} />) : ""

       

        if (this.state.loaded) {
            return (
                <div className={Styles.Details}>
                    {this.state.editScreen ? this.state.editScreen : ""}
                    <div className={Styles.TopBar}>
                        <div className={Styles.Back} onClick={() => {
                                if (this.props.history.location.state != null && this.props.history.location.state.from === '/hcp') {
                                    this.props.history.push({
                                        pathname: '/hcp',
                                        state: {
                                            from: '/hcp/details'
                                        }
                                    })
                                }
                                else {
                                    this.props.history.go(-1)
                                }
                            }}><span aria-hidden="true">‹</span>BACK TO SEARCH</div>
                    </div>
                    <div className={Styles.pageWrapper}>
                        <div className={Styles.Wrapper}>
                            {this.state.data && this.state.addresses && this.state.ctmsAddress && this.state.msl
                                ? <DetailsInformation editScreen={this.editScreen.bind(this)} submitEdit={this.submitEdit.bind(this)} user={this.props.user} data={{ ...this.state.data, ...this.state.toggleState }} loadChange={this.loadChange.bind(this)} number={this.props.number} addresses={this.state.addresses} msl={this.state.msl} ctmsAddress={this.state.ctmsAddress} addTo={this.addTo.bind(this)}/>
                                : <Loading />}
                        </div>
                        <div className={Styles.Wrapper}>
                            <AddressAlignment/>
                        </div>
                        <div className={Styles.Wrapper}>
                            <AddressHistory addresses={this.state.addresses} />
                        </div>
                        <div className={Styles.Wrapper}>
                            <SlnHistory slnHistory={this.state.sln} addSLN={this.openSLNEdit.bind(this)} user={this.props.user} />
                        </div>
                        <div className={Styles.Wrapper}>
                            <DetailsAffiliations editScreen={this.editScreen.bind(this)} user={this.props.user} data={this.state.affiliations}/>
                        </div>
                        <div className={Styles.Wrapper}>
                            <DetailsChangeRequests data={this.state.change} prev={this.props.data} editScreen={this.editScreenChangeRequest.bind(this)}/>
                        </div>
                    </div>
                    {successDialog}
                </div>
            );

        }
        else {
            if (this.state.pathError) {
                return (<div ><br/>&nbsp;&nbsp;Error loading data.  Please refresh the page.</div>)
            } else {
                return (<Loading />)
            }
            
        }
    }
}

export default withAITracking(reactPlugin, withRouter(HcpDetails));